import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Input } from './ui/input';

export const isStrongPassword = (pw) => pw.length >= 8 && /[A-Za-z]/.test(pw) && /\d/.test(pw);

export const PasswordInput = ({ testId, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
      <Input
        {...props}
        type={visible ? 'text' : 'password'}
        placeholder="••••••••"
        className="pl-12 pr-12 h-12 rounded-xl border-gray-200 bg-white/50 focus:ring-2 focus:ring-primary/20 text-base"
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-1 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-700 transition-colors"
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        data-testid={`${testId}-toggle`}
      >
        {visible ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
};
